// eslint-disable-next-line no-unused-vars
import { useSelector } from "react-redux";
import { Container, Spinner } from "react-bootstrap";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import PropertySingle from "./PropertySingle";
import { useParams } from 'react-router-dom';
import { useState } from "react";

const PropertyItem = () => { 
  const { Id } = useParams();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Property", link: "/property", active: true },
    { label: Id, link: `/property/${Id}`, active: true },
  ];

  return ( 
    <Container className="my-4">
      <BreadCrumb items={breadcrumbItems} />
      <PropertySingle backBtn={'/property'}/>
    </Container>
  );
};

export default PropertyItem; 